// Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved

import { css } from 'emotion';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { deleteTodo } from '../actions';

const TodoItem = ({ index }: { index: number }) => {

  const { todo, removeTodo } = useTodo(index);

  return (
    <li className={styles.root}>
      <span>{todo}</span>
      <button onClick={removeTodo}>Delete</button>
    </li>
  );
}

// Example of creating a custom hook to encapsulate the store
function useTodo(index: number): { todo: string; removeTodo: () => void } {

  const todo: string = useSelector((state: any) => state.Todo.todos[index])

  const dispatch = useDispatch();
  const removeTodo: any = useCallback(() => dispatch(deleteTodo(index)), [
    dispatch,
    index,
  ]);
  return { todo, removeTodo };
}

const styles = {
  root: css`
    display: flex;
    justify-content: space-between;
    list-style-type: none;
    margin: 0;
    padding: 8px 12px;

    &:hover {
      background-color: #efefef;

      button {
        display: block;
      }
    }

    button {
      display: none;
    }
  `,
};
export default TodoItem